import * as React from 'react';

import {
  Activity,
  ApiQuestionResponse,
  QuestionScore,
  Student,
} from '~teacher/models/activities';
import { QuizAnswer, QuizQuestion } from '~teacher/models/quizzes';

import { normalizeQuestions } from './util/normalizeQuestions';
import { normalizeResponses } from './util/normalizeResponses';
import { normalizeStudent } from './util/normalizeStudent';
import { parseQuestionData } from './util/parseQuestionData';

interface Props {
  activity: Activity;
  answers: Record<string, QuizAnswer>;
  questions: Record<string, QuizQuestion>;
  responses: Record<string, ApiQuestionResponse>;
  students: Record<string, Student>;
  questionPosition: number;
  questionScores: Record<number, QuestionScore>;
  roomName?: string;
  isRosteredRoom: boolean;
  isLive: boolean;
}

export const useNormalizedQuestion = (props: Props) => {
  const keyedResponses = props.responses;
  const keyedStudents = props.students;

  const questions = React.useMemo(
    () => normalizeQuestions(props.questions),
    [props.questions]
  );

  const responses = normalizeResponses({
    students: keyedStudents,
    responses: keyedResponses,
    quizQuestion: props.questions,
  });

  const students = React.useMemo(
    () => normalizeStudent(keyedStudents),
    [keyedStudents]
  );
  const parsedData = parseQuestionData({
    questionScores: props.questionScores,
    answers: props.answers,
    questions: questions,
    responses: responses,
    students: students,
    questionPosition: props.questionPosition,
  });

  return {
    ...parsedData,
    questions: questions,
  };
};
